import React from 'react'
import './App.css';

export default function TermsScreen() {
  return (
    <div className="content-screen">
      <h1>Terms & Conditions and Privacy Policy</h1>
      <div className="content">
        <p className="last-updated">Last Updated: 21-10-2025</p>
        <p>Welcome to ActivoLog ("Application", "Service"), operated by ActivoLog, ("Company", "We", "Us", "Our"). This document governs your use of the Application and explains how we collect, use, and protect your information. By accessing or using the Service, you agree to be bound by these Terms & Conditions and Privacy Policy.</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By downloading, installing, accessing, or using the Application, you confirm that you have carefully read, fully understood, and agreed to be legally bound by these Terms & Conditions and Privacy Policy. Your use of the Service indicates your continued acceptance of these terms. If you do not agree with any part of these Terms, you must immediately stop using the Application and uninstall it from your device.</p>

        <h2>2. Nature of Service (Important Disclaimer)</h2>
        <p>Activolog is provided strictly for entertainment and informational purposes. The Application does not provide real-time access to private communications, including but not limited to messaging platforms or social media services. It does not hack, intercept, monitor, or retrieve actual private conversations or personal data from any third party.</p>
        <p>Any content, results, or outputs displayed within the Application are system-generated, simulated, or illustrative in nature and should not be interpreted as real or factual information. By using the Service, you acknowledge that the results may not reflect real-world data and must not be relied upon for decision-making.</p>

        <h2>3. In-App Purchases & Subscription Policy</h2>
        <p>The Application offers features that require payment through in-app purchases. Users may be charged an initial fee (for example, a one-day introductory offer), followed by a weekly auto-renewable subscription.</p>
        <p>Payments are processed through your Google Play account and will automatically renew unless canceled. By purchasing a subscription, you authorize recurring billing based on your selected plan.</p>
        <p>You may cancel your subscription at any time via your Google Play account settings. Cancellation will stop future billing but will not affect the current active subscription period.</p>
        <p>All purchases are made at your own discretion. Refunds are not provided except as required by applicable law or Google Play policies.</p>
        <p>Subscription auto-renews unless canceled.</p>

        <h2>4. Third-Party Services & Dependencies</h2>
        <p>The Application may rely on third-party services such as analytics tools, APIs, or hosting providers. These services are not controlled by the Company and may change or become unavailable at any time.</p>
        <p>We are not responsible for any issues, inaccuracies, or disruptions caused by third-party services.</p>

        <h2>5. User Responsibility & Acceptable Use</h2>
        <p>You agree to use the Application only for lawful purposes. You must not:</p>
        <ul>
          <li>Attempt unauthorized access to any data</li>
          <li>Use the app for illegal activities</li>
          <li>Violate the privacy of others</li>
        </ul>
        <p>You are solely responsible for your actions while using the Service.</p>

        <h2>6. Privacy & Security Responsibility</h2>
        <p>You are responsible for maintaining the security of your device and any information you share. The Application does not provide access to real private data, and misuse is strictly prohibited.</p>

        <h2>7. Age Restriction</h2>
        <p>The Application is intended only for users aged 18 years or older. If you are under 18, you must not use the Application or make purchases.</p>

        <h2>8. Personal Data Collection</h2>
        <p>We may collect:</p>
        <ul>
          <li>Name, email, phone number (if provided)</li>
          <li>Device information</li>
          <li>Usage data</li>
          <li>Analytics data</li>
        </ul>
        <p>This data is collected only when necessary.</p>

        <h2>9. Use of Personal Data</h2>
        <p>We use your data to:</p>
        <ul>
          <li>Provide and improve the app</li>
          <li>Process subscriptions</li>
          <li>Send updates and notifications</li>
          <li>Analyze usage</li>
          <li>Prevent fraud and abuse</li>
        </ul>

        <h2>10. Identity Verification</h2>
        <p>In some cases, we may request identity verification to prevent fraud or ensure platform security. This data is handled securely.</p>

        <h2>11. Data Sharing</h2>
        <p>We may share data with:</p>
        <ul>
          <li>Service providers</li>
          <li>Analytics partners</li>
          <li>Legal authorities (if required)</li>
        </ul>
        <p>We do not sell your personal data.</p>

        <h2>12. Data Retention</h2>
        <p>We retain data only as long as necessary for:</p>
        <ul>
          <li>Providing services</li>
          <li>Legal compliance</li>
          <li>Dispute resolution</li>
        </ul>

        <h2>13. Data Transfer</h2>
        <p>Your data may be stored and processed in different countries. By using the app, you consent to this transfer.</p>

        <h2>14. Data Deletion Rights</h2>
        <p>You can request:</p>
        <ul>
          <li>Access</li>
          <li>Correction</li>
          <li>Deletion</li>
        </ul>
        <p>by contacting us.</p>

        <h2>15. Security of Data</h2>
        <p>We use reasonable security measures, but no system is 100% secure.</p>

        <h2>16. Limitation of Liability</h2>
        <p>We are not liable for:</p>
        <ul>
          <li>Data loss</li>
          <li>Financial loss</li>
          <li>Service issues</li>
        </ul>
        <p>Use the app at your own risk.</p>

        <h2>17. Modifications and Updates</h2>
        <p>We may update these Terms at any time. Continued use means acceptance of changes.</p>

        <h2>18. Termination</h2>
        <p>We may suspend or terminate access if you violate these Terms.</p>

        <h2>19. Governing Law</h2>
        <p>These Terms are governed by the laws of Turkey.</p>

        <h2>20. Contact Information</h2>
        <p>For any questions:</p>
        <p>📧 Email: info.gemmure@gmail.com</p>
      </div>
    </div>
  )
}

